import { Box, List, ListItem, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';
import _HomeIcon from '@/assets/images/icons/hypertracker_home_menu_item.svg?react';
import _HeatmapIcon from '@/assets/images/icons/hypertracker_heatmap_menu_item.svg?react';
import _CohortIcon from '@/assets/images/icons/hypertracker_cohorts_menu_item.svg?react';
import _FavoritesIcon from '@/assets/images/icons/hypertracker_favorites_menu_item.svg?react';
import _ConnectionsIcon from '@/assets/images/icons/hypertracker_connections_menu_item.svg?react';
import _LeaderboardIcon from '@/assets/images/icons/hypertracker_leaderboards_menu_item.svg?react';
import _PerpsIcon from '@/assets/images/icons/hypertracker_perps_menu_icon.svg?react';
import _StatsIcon from '@/assets/images/icons/hypertracker_stats_menu_item.svg?react';
import _CmmLogoShort from '@/assets/images/icons/logo_white_short.svg?react';
import _BuildersIcon from '@/assets/images/icons/hypertracker_builder_menu_item.svg?react';
import _ApiIcon from '@/assets/images/icons/hypertracker_api_menu_item.svg?react';
import _KeyIcon from '@/assets/images/icons/key_icon.svg?react';
import _BellIcon from '@/assets/images/icons/hypertracker_alerts_menu_item.svg?react';
import _FlowsIcon from '@/assets/images/icons/hypertracker_flows_menu_item.svg?react';
import _LiquidationsIcon from '@/assets/images/icons/hypertracker_liquidations_menu_item.svg?react';
import _HipIcon from '@/assets/images/icons/hypertracker_hip3_menu_icon.svg?react';
import _MarketRadarIcon from '@/assets/images/icons/hypertracker_radar_menu_icon.svg?react';
import _DashboardIcon from '@/assets/images/portfolio_cmm.svg?react';
import _LinkIcon from '@/assets/images/icons/link_outer_icon.svg?react';
import _HomeMobileIcon from '@/assets/images/icons/hypertracker_home_menu_mobile_icon.svg?react';
import _HeatmapMobileIcon from '@/assets/images/icons/hypertracker_heatmap_menu_mobile_icon.svg?react';
import _CohortMobileIcon from '@/assets/images/icons/hypertracker_cohorts_menu_mobile_icon.svg?react';
import _FavoritesMobileIcon from '@/assets/images/icons/hypertracker_favorites_menu_mobile_icon.svg?react';
import _LeaderboardMobileIcon from '@/assets/images/icons/hypertracker_leaderboards_menu_mobile_icon.svg?react';
import _PerpsMobileIcon from '@/assets/images/icons/hypertracker_perps_menu_mobile_icon.svg?react';
import _StatsMobileIcon from '@/assets/images/icons/hypertracker_stats_menu_mobile_icon.svg?react';
import _BuildersMobileIcon from '@/assets/images/icons/hypertracker_builder_menu_mobile_icon.svg?react';
import _ApiMobileIcon from '@/assets/images/icons/hypertracker_api_menu_mobile_icon.svg?react';
import _BellMobileIcon from '@/assets/images/icons/hypertracker_alerts_menu_mobile_icon.svg?react';
import _LiquidationsMobileIcon from '@/assets/images/icons/hypertracker_liquidations_menu_mobile_icon.svg?react';
import _MarketRadarMobileIcon from '@/assets/images/icons/hypertracker_radar_menu_mobile_icon.svg?react';
import _DashboardMobileIcon from '@/assets/images/icons/dashboard_menu_mobile_icon.svg?react';
import _AlphafeedIcon from '@/assets/images/hypertracker/alphafeed_gray.svg?react';
import _AlphafeedFullIcon from '@/assets/images/hypertracker/alphafeed_landing_logo.svg?react';

export const StyledList = styled(List)(() => ({
    paddingBottom: '0',
    gap: '12px',
}));

export const BlurredContainer = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px',
    zIndex: 1001,
    backgroundColor: theme.palette.backgrounds.modalBlurredBg,
    backdropFilter: 'blur(9.800000190734863px)',
}));

export const StyledItemText = styled(ListItemText)({
    transition: 'opacity 0.4s',
});

export const StyledListItem = styled(ListItem)({
    display: 'flex',
    height: '32px',
});

export const HomeIcon = styled(_HomeIcon)({
    width: '16px',
    height: '16px',
});

export const DashboardIcon = styled(_DashboardIcon)({});

export const HeatmapIcon = styled(_HeatmapIcon)({
    width: '16px',
    height: '16px',
});

export const CohortIcon = styled(_CohortIcon)({
    width: '16px',
    height: '16px',
});

export const FavoritesIcon = styled(_FavoritesIcon)({
    width: '16px',
    height: '16px',
});

export const ConnectionsIcon = styled(_ConnectionsIcon)({
    width: '16px',
    height: '16px',
});

export const LeaderboardIcon = styled(_LeaderboardIcon)({
    width: '16px',
    height: '16px',
});

export const PerpsIcon = styled(_PerpsIcon)({
    width: '16px',
    height: '16px',
});

export const StatsIcon = styled(_StatsIcon)({
    width: '16px',
    height: '16px',
});

export const BuildersIcon = styled(_BuildersIcon)({
    width: '16px',
    height: '16px',
});
export const AlertsIcon = styled(_BellIcon)({
    width: '16px',
    height: '16px',
});

export const ApiIcon = styled(_ApiIcon)({
    width: '16px',
    height: '16px',
});

export const KeyIcon = styled(_KeyIcon)({
    width: '16px',
    height: '16px',
});

export const FlowsIcon = styled(_FlowsIcon)({
    width: '16px',
    height: '16px',
});

export const LiquidationsIcon = styled(_LiquidationsIcon)({
    width: '16px',
    height: '16px',
});

export const HipIcon = styled(_HipIcon)({
    width: '16px',
    height: '16px',
});

export const MarketRadarIcon = styled(_MarketRadarIcon)({
    width: '16px',
    height: '16px',
});

export const CmmLogoShort = styled(_CmmLogoShort)(({ theme }) => ({
    width: '24px',
    height: 'auto',
    aspectRatio: '1 / 1',
    borderRadius: '100px',
    backgroundColor: `${theme.palette.hypertracker.dark}0D`,
    path: { fill: theme.palette.hypertracker.light, fillOpacity: 1 },
}));

export const CollapseTitleSelect = styled(Box)({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px 16px',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: '#1A1A1F',
    },
});

export const CollapsibleWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '12px',
    padding: '8px',
});

export const ListWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '12px',
    padding: '4px 8px',
});

export const CollapseListItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    cursor: 'pointer',
    paddingLeft: '8px',
    '&:hover p': {
        color: theme.palette.hypertracker.main,
    },
    '&:hover span': {
        color: theme.palette.hypertracker.main,
    },
}));

export const ListItemButtonContent = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'flex-start',
    borderRadius: '8px',
    padding: '4px 8px',
    transition: 'background-color 0.2s ease',
    opacity: 0.7,
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        opacity: 1,
    },
}));

export const StyledLink = styled('a')({
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
    width: '100%',
});

export const LinkIcon = styled(_LinkIcon)({
    width: '16px',
    height: '16px',
});

export const HomeMobileIcon = styled(_HomeMobileIcon)({
    width: '16px',
    height: '16px',
});

export const DashboardMobileIcon = styled(_DashboardMobileIcon)({});

export const HeatmapMobileIcon = styled(_HeatmapMobileIcon)({
    width: '16px',
    height: '16px',
});

export const CohortMobileIcon = styled(_CohortMobileIcon)({
    width: '16px',
    height: '16px',
});

export const FavoritesMobileIcon = styled(_FavoritesMobileIcon)({
    width: '16px',
    height: '16px',
});

export const LeaderboardMobileIcon = styled(_LeaderboardMobileIcon)({
    width: '16px',
    height: '16px',
});

export const PerpsMobileIcon = styled(_PerpsMobileIcon)({
    width: '16px',
    height: '16px',
});

export const StatsMobileIcon = styled(_StatsMobileIcon)({
    width: '16px',
    height: '16px',
});

export const BuildersMobileIcon = styled(_BuildersMobileIcon)({
    width: '16px',
    height: '16px',
});

export const AlertsMobileIcon = styled(_BellMobileIcon)({
    width: '16px',
    height: '16px',
});

export const ApiMobileIcon = styled(_ApiMobileIcon)({
    width: '16px',
    height: '16px',
});

export const LiquidationsMobileIcon = styled(_LiquidationsMobileIcon)({
    width: '16px',
    height: '16px',
});

export const MarketRadarMobileIcon = styled(_MarketRadarMobileIcon)({
    width: '16px',
    height: '16px',
});

export const AlphafeedMobileIcon = styled(_AlphafeedIcon)({
    width: '16px',
    height: '16px',
});

export const AlphaFeedBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',

    width: '40px',
    height: '40px',
    background:
        'linear-gradient(0deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), #000',
    padding: '4px 8px',
    borderRadius: '8px',
    margin: '10px 0 8px 10px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    '&:hover': {
        backgroundColor: theme.palette.primitives.sun[700],
    },
    '&:active': {
        backgroundColor: theme.palette.primitives.sun[800],
    },
}));

export const AlphafeedFullIcon = styled(_AlphafeedFullIcon)({
    path: { fill: '#000000' },
    width: '100px',
    height: 'auto',
});
